const shippingPolicyLink = document.querySelector(".shipping-policy");
const modal = document.querySelector(".shipping-policy-modal");
const closeModalButton = document.querySelector(".close-modal");

shippingPolicyLink.addEventListener("click", function () {
  modal.classList.add("tw-flex");
  modal.classList.remove("tw-hidden");
});

closeModalButton.addEventListener("click", function () {
  modal.classList.remove("tw-flex");
  modal.classList.add("tw-hidden");
});

function closeAllFaqs() {
  document.querySelectorAll(".faq-answer").forEach(function (answer) {
    answer.classList.remove("tw-block");
    answer.classList.add("tw-hidden");
  });

  document.querySelectorAll(".faq-icon-up").forEach(function (icon) {
    icon.classList.remove("tw-flex");
    icon.classList.add("tw-hidden");
  });

  document.querySelectorAll(".faq-icon-down").forEach(function (icon) {
    icon.classList.remove("tw-hidden");
    icon.classList.add("tw-flex");
  });
}

function openFaq(faqContainer) {
  const answer = faqContainer.querySelector(".faq-answer");
  const iconUp = faqContainer.querySelector(".faq-icon-up");
  const iconDown = faqContainer.querySelector(".faq-icon-down");

  answer.classList.remove("tw-hidden");
  answer.classList.add("tw-block");

  iconDown.classList.remove("tw-flex");
  iconDown.classList.add("tw-hidden");
  iconUp.classList.remove("tw-hidden");
  iconUp.classList.add("tw-flex");
}

document.querySelectorAll(".faq-title").forEach(function (title) {
  title.addEventListener("click", function () {
    const faqContainer = this.closest(".faq-container");
    const isOpen = faqContainer
      .querySelector(".faq-answer")
      .classList.contains("tw-block");

    closeAllFaqs();

    if (!isOpen) {
      openFaq(faqContainer);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const thumbnails = document.querySelectorAll(
    ".product-thumbnails img, .product-thumbnails-secondary img"
  );

  const activatedInformation = document.querySelector(".activated-information");

  const mainImage = document.getElementById("main-image");

  let currentIndex = 0;

  function updateMainImage(index) {
    if (index >= 0 && index < thumbnails.length) {
      const thumbnail = thumbnails[index];
      const newSrc = thumbnail.src;

      mainImage.src = newSrc;

      thumbnails.forEach((thumb) => {
        thumb.classList.remove("tw-border", "tw-border-grey-300");
      });

      thumbnail.classList.add("tw-border", "tw-border-grey-300");

      activatedInformation.classList.forEach((className) => {
        if (className.startsWith("prod_index-")) {
          activatedInformation.classList.remove(className);
        }
      });

      activatedInformation.classList.add(`prod_index-${index + 1}`);

      currentIndex = index;
    }
  }

  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener("click", function () {
      updateMainImage(index);
    });
  });

  function goToNextImage() {
    const nextIndex = (currentIndex + 1) % thumbnails.length;
    updateMainImage(nextIndex);
  }

  function goToPreviousImage() {
    const previousIndex =
      (currentIndex - 1 + thumbnails.length) % thumbnails.length;
    updateMainImage(previousIndex);
  }

  const navRight = document.querySelector(".product-nav-right");
  const navLeft = document.querySelector(".product-nav-left");

  if (navRight) {
    navRight.addEventListener("click", goToNextImage);
  }

  if (navLeft) {
    navLeft.addEventListener("click", goToPreviousImage);
  }
});

const pricePerBottle = 59.99;

document.querySelectorAll(".item").forEach((item) => {
  item.addEventListener("click", function () {
    document.querySelectorAll(".item").forEach((i) => {
      i.classList.remove("tw-border-grey-300");
      i.classList.remove("item-selected");
    });

    this.classList.add("tw-border-grey-300");
    this.classList.add("item-selected");

    const quantityText = this.querySelector(".tw-text-grey-500").textContent;
    const quantityMatch = quantityText.match(/(\d+) bottle/);
    const quantity = quantityMatch ? parseInt(quantityMatch[1]) : 1;
    document.getElementById("selected-quantity").value = quantity;
    document.getElementById("quantity-input").value = quantity;

    updateBorderClass(quantity);
    updatePrice(quantity);
  });
});

document
  .getElementById("increase-quantity")
  .addEventListener("click", function () {
    let currentQuantity = parseInt(
      document.getElementById("quantity-input").value
    );
    if (currentQuantity < 99) {
      currentQuantity += 1;
      document.getElementById("quantity-input").value = currentQuantity;
      document.getElementById("selected-quantity").value = currentQuantity;

      updateBorderClass(currentQuantity);
      updatePrice(currentQuantity);
    }
  });

document
  .getElementById("decrease-quantity")
  .addEventListener("click", function () {
    let currentQuantity = parseInt(
      document.getElementById("quantity-input").value
    );
    if (currentQuantity > 1) {
      currentQuantity -= 1;
      document.getElementById("quantity-input").value = currentQuantity;
      document.getElementById("selected-quantity").value = currentQuantity;

      updateBorderClass(currentQuantity);
      updatePrice(currentQuantity);
    }
  });

function updateBorderClass(quantity) {
  document.querySelectorAll(".item").forEach((item) => {
    item.classList.remove("tw-border-grey-500");
  });

  if (quantity === 1) {
    document.getElementById("one-item").classList.add("tw-border-grey-500");
  } else if (quantity === 3) {
    document.getElementById("three-items").classList.add("tw-border-grey-500");
  } else if (quantity === 6) {
    document.getElementById("six-items").classList.add("tw-border-grey-500");
  }
}

function updatePrice(quantity) {
  let price = pricePerBottle * quantity;

  if (quantity === 3) {
    price *= 0.95;
  } else if (quantity === 6) {
    price *= 0.9;
  }

  document.getElementById("priceSelected").textContent = `$${price.toFixed(2)}`;
  document.getElementById(
    "priceSelectedMobile"
  ).textContent = `$${price.toFixed(2)}`;
}

updatePrice(1);

function addToCart(variantId, quantity) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: quantity,
        },
      ],
    }),
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error("Error adding product to cart");
    })
    .then((data) => {
      console.log("Product added to cart:", data);
    })
    .catch((error) => {
      console.error("Erro:", error);
    });
}

document.addEventListener("click", function (event) {
  if (event.target.id === "quick-add") {
    var id = "7443182157858";

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: id,
        quantity: 1,
      }),
    })
      .then((response) => {
        if (response.ok) {
          window.location.href = "/cart";
        } else {
          console.error("Error adding item to cart");
        }
      })
      .catch((error) => console.error("Error:", error));
  }
});

document.querySelector(".menu-mobile").addEventListener("click", function () {
  const closeMenu = document.querySelector(".close-menu-svg");
  const menuDrawer = document.querySelector("#menu-drawer");

  menuDrawer.classList.remove("!tw-invisible");
  closeMenu.classList.remove("tw-hidden");
  closeMenu.classList.add("tw-flex");

  menuDrawer.classList.add("!tw-transform-none");
});
